/* ===== Client template registry — apply/restore per theme (isolation) ===== */

/** @type {Map<string, { apply?: (settings?: object) => void | Promise<void>, restore?: () => void | Promise<void> }>} */
const templateHandlers = new Map();

/**
 * Register a template's apply/restore hooks.
 * restore = undo ONLY this template's DOM/CSS inline changes.
 */
export function registerClientTemplate(id, handlers = {}) {
  const key = String(id || '').trim().toLowerCase();
  if (!key) return;
  templateHandlers.set(key, {
    apply: typeof handlers.apply === 'function' ? handlers.apply : null,
    restore: typeof handlers.restore === 'function' ? handlers.restore : null
  });
}

export function getRegisteredClientTemplates() {
  return [...templateHandlers.keys()];
}

/** Run every registered restore (safe to call when switching themes). */
export async function restoreAllClientTemplates() {
  const restores = [...templateHandlers.values()]
    .map((h) => h.restore)
    .filter(Boolean);
  for (const restore of restores) {
    await restore();
  }
}

/** Apply DOM fixes for a single template id (call after global restore). */
export async function applyClientTemplateDom(id, settings = {}) {
  const key = String(id || '').trim().toLowerCase();
  const handler = templateHandlers.get(key);
  if (!handler?.apply) return;
  await handler.apply(settings);
}
